import { ReactNode } from "react";
import { Modal, ModalProps } from "react-bootstrap";

interface SignOutConfirmModalProps extends ModalProps {
  onHide: () => void;
  onConfirm: () => void;
  title?: ReactNode;
  message?: ReactNode;
  cancelLabel?: string;
  confirmLabel?: string;
}

const SignOutConfirmModal = ({
  onHide,
  onConfirm,
  title,
  message = "You will be automatically logged out due to inactivity.",
  cancelLabel = "Cancel",
  confirmLabel = "Logout",
  className,
  ...props
}: SignOutConfirmModalProps) => {
  return (
    <Modal
      {...props}
      onHide={onHide}
      backdrop="static"
      backdropClassName="confirmationModalBackdrop"
      className={["mainMenuModal", "confirmationModal", className].filter(Boolean).join(" ")}
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body className="">
        <div className="otpModalBody p-4">
          {title ? (
            <div className="confirmationModalTitle mb-3" style={{ fontSize: "32px", fontWeight: 700, marginBottom: "12px" }}>
              {title}
            </div>
          ) : null}
          <div className="header" style={{ fontSize: "22px" }}>
            {message}
          </div>
          <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
            <button
              type="button"
              className="btnYesMenu"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onConfirm();
              }}
            >
              {confirmLabel}
            </button>
            <button
              type="button"
              className="btnCancelMenu"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onHide();
              }}
            >
              {cancelLabel}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SignOutConfirmModal;
